<template>
  <!-- 已确认入金 -->
  <div class="opage">
    <div>
      <!-- 已确认入金 -->
      <baseBreadcrumb :page="$t('message.depositConfirmed')" :menu="$t('message.money')"></baseBreadcrumb>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 类别 -->
          <div class="item">
            <el-select v-model='searchType' :placeholder="$t('message.category')" clearable>
              <el-option label='客户名' value='realname'>
              </el-option>
              <el-option label='客户ID' value='user_id'>
              </el-option>
              <el-option label='订单号' value='order_sn'>
              </el-option>
              <el-option label='配送单号' value='porder_sn'>
              </el-option>
            </el-select>
          </div>
          <!-- 订单号.派送单号 -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="searchInput" :placeholder="$t('message.searchContent')" clearable>
            </el-input>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search" style="margin-right: 20px;">
            {{ $t("message.search") }}
          </el-button>
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px"
              clearable>
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px"
              clearable>
            </el-date-picker>
          </div>
          <!-- 银行筛选 -->
          <div class="item">
            <!-- 支付方式 -->
            <el-select v-model="datas.bill_method" :placeholder="$t('message.methodPayment')" @change="search"
              filterable clearable>
              <el-option v-for="item in BillMethod" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>

          </div>
          <!-- 筛选 -->
          <el-button type="primary" @click="search">
            {{ $t("message.filter") }}
          </el-button>
          <!-- 重置 -->
          <!-- <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button> -->
        </div>
      </div>
      <div class="body">
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 入金时间 -->
            <li>{{ $t('message.depositTime') }}</li>
            <!-- 确认入金时间 -->
            <li>{{ $t('message.confirmDepositTime') }}</li>
            <!-- 客户 -->
            <li class="flex15">{{ $t('message.user') }}</li>
            <!-- 业务员 -->
            <li>{{ $t('message.salesman') }}</li>
            <!-- 账务类别 -->
            <li>{{ $t('message.accountingCategory') }}</li>
            <!-- 单子信息 -->
            <li class="flex2">{{ $t('message.orderInformations') }}</li>
            <!-- 汇款人姓名 -->
            <li>{{ $t('message.nameRemitter') }}</li>
            <!-- 汇款金额. 円 -->
            <li>{{ $t('message.remittanceAmountYen') }}</li>
            <!-- 账户余额. 円 -->
            <li>{{ $t('message.accountBalanceYen') }}</li>
            <!-- 支付方式 -->
            <li>{{ $t('message.methodPayment') }}</li>
            <!-- 转账备注 -->
            <li class="flex15">{{ $t('message.transferNote') }}</li>
            <!-- 操作 -->
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!-- 入金时间 -->
            <li>
              <div class="time">{{ item.created_at }}</div>
            </li>
            <!-- 确认入金时间 -->
            <li>
              <div class="time">{{ item.confirm_at }}</div>
            </li>
            <!-- 客户 -->
            <li class="flex15">
              <div class="keHu">
                <p>{{ item.user ? item.user.realname : "" }}</p>
                <p>ID:{{ item.user_id }}</p>
                <!-- 联系方式 -->
                <el-popover popper-class="zdyPopver" placement="bottom-start" trigger="click"
                  :title="$t('message.customerContactInformation') + ':'" v-if="item.user">
                  <div class="reveal">
                    <!-- 业务员 -->
                    <p>{{ $t("message.salesman") }}:{{ item.y_name }}</p>
                    <p>Email：{{ item.user.email }}</p>
                    <p>Mobile：{{ item.user.mobile }}</p>
                  </div>
                  <!-- 信息查看 -->
                  <p class="lookMore" slot="reference">
                    {{ $t("message.CheckInformation") }}
                  </p>
                </el-popover>
              </div>
            </li>
            <!-- 业务员 -->
            <li>{{ item.y_name }}</li>
            <!-- 账务类别 -->
            <li>{{ item.bill_type_name }}</li>
            <!-- 单子信息 -->
            <li class="flex2">
              <div v-if="item.order_sn">
                <!-- 配送单详情链接 -->
                <router-link v-if="item.order_sn.substr(0, 1) == 'P'" class="redFont"
                  :to="'/porderDetail?porder_sn=' + item.order_sn" target="_blank">
                  {{ item.order_sn }}
                </router-link>
                <!-- 订单详情链接 -->
                <router-link v-else class="redFont" :to="'/orderDetail?order_sn=' + item.order_sn" target="_blank">
                  {{ item.order_sn }}
                </router-link>
              </div>
            </li>
            <!-- 汇款人姓名 -->
            <li>{{ item.pay_realname }}</li>
            <!-- 汇款金额. 円 -->
            <li>{{ item.amount }}</li>
            <!-- 账户余额. 円 -->
            <li>{{ item.balance }}</li>
            <!-- 支付方式 -->
            <li>{{ item.bill_method_name }}</li>
            <!-- 转账备注 -->
            <li class="flex15">{{ item.pay_remark }}</li>
            <!-- 操作 -->
            <li>
              <!--title: 汇款明细 -->
              <el-popover popper-class="zdyPopver" placement="bottom" trigger="click"
                :title="$t('message.remittanceDetails') + ':'" v-if="item.user">
                <div class="reveal">
                  <!-- 提出时间 -->
                  <p>{{ $t('message.forwardTime') }}{{ item.user.created_at }}</p>
                  <!-- 汇款截图:  -->
                  <p>
                    <span>{{ $t("message.remittanceScreenshots") }}:</span>
                    <el-popover v-if="item.pay_image" placement='right' trigger='hover'>
                      <img :src='item.pay_image' alt='' style='width:300px ; height:300px' />
                      <el-image class="payImg" :src="item.pay_image" slot='reference'>
                        <div slot='error' class='image-slot'>
                          <i class='el-icon-picture-outline'></i>
                        </div>
                        <div slot='placeholder'>
                          <i class='el-icon-loading'></i>
                        </div>
                      </el-image>
                    </el-popover>

                  </p>
                </div>
                <!-- 汇款截图 -->
                <p class="lookMore" slot="reference">
                  {{ $t("message.remittanceScreenshots") }}
                </p>
              </el-popover>
            </li>
          </ul>
          <!-- 暂无数据 -->
          <div v-if="tableData == false" class="No_data">{{ $t('message.noDataYet') }}</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {},
      tableData: [],
      total: 0,
      searchType: '',//搜索类别
      searchInput: '',
      BillMethod: [],
    };
  },
  component: {},
  created() {
    this.confirmedList();
    this.getbillMethods()
  },
  methods: {
    // 获取支付列表
    getbillMethods() {
      this.$api.financialApi.billBillMethod().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.msg);
        res.data.unshift(
          { key: '', value: "すべて", is_bank: 0 }
        )
        this.BillMethod = res.data;
      });
    },
    // 重置
    reset() {
      this.datas = {};
      this.searchInput = ''
      this.searchType = ''
      this.confirmedList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.confirmedList();
    },
    // 获取配送单列表
    confirmedList() {
      let returnDatas = JSON.parse(JSON.stringify(this.datas))
      returnDatas[this.searchType] = this.searchInput
      this.$api.financialApi.confirmedList(returnDatas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.confirmedList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.confirmedList();
    },
  },
};
</script>
<style lang='scss' scoped>
.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}



.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.search {
  margin: 24px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
    align-items: center;

    >* {
      margin-bottom: 26px;
    }
  }
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .time {
    text-align: center;
  }



  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.keHu {
  p {
    text-align: center;
  }
}

.reveal {
  padding: 16px;

  p {
    font-size: 14px;
    line-height: 20px;
    padding: 5px;
    display: flex;
    align-items: center;
  }

  /deep/.el-image,
  .payImg {
    $imgSize: 80px;
    width: $imgSize;
    height: $imgSize;
    transition: 0.3s;
    text-align: center;

    i {
      font-size: $imgSize/4;
      line-height: $imgSize;
    }
  }

}

.lookMore {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
</style>
